module.exports = __webpack_public_path__ + "static/media/head-black.67f37307.jpg";